import { privateFetch } from "../libs/axios"
import {
  BookingFilterParams,
  RebookRequestType,
  UpdateBookingStatusRequestType,
  RecentBookingsParams,
} from "../types/BookingInfoTypes"
import { jsonToQueryString } from "../utils/Common"

export const cancelMultipleBookings = async (body: any) =>
  await privateFetch().post("/api/v1/booking/cancel-multiple-bookings", body)

export const rebook = async (bookingId: string, body: RebookRequestType, filter = {}) =>
  await privateFetch().post(`/api/v1/re-book/${bookingId}${jsonToQueryString(filter)}`, body)

export const index = async (params: BookingFilterParams) =>
  await privateFetch().get("/api/v1/booking", { params })

export const getBooking = async (bookingID: string) =>
  await privateFetch().get(`/api/v1/booking/details/${bookingID}`)

export const updateStatus = async (bookingId: string, body: UpdateBookingStatusRequestType) =>
  await privateFetch().post(`/api/v1/booking/${bookingId}/update-status`, body)

export const recentBookings = async (params: RecentBookingsParams) =>
  await privateFetch().get("/api/v1/recent-bookings", { params })
